var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"labeled-icon-wrapper"},[_c('div',{staticClass:"icon"},[_vm._t("icon")],2),_c('div',{staticClass:"label",attrs:{"dir":"auto"}},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }